{
  "blog.title": "Blog",
  "blog.lead": "Artikelen per taal: AI stelt een concept voor, jij herschrijft en keurt goed.",
  "blog.lead_site": "Artikelen voor {site}: AI stelt een concept voor, jij herschrijft en keurt goed.",
  "blog.site": "Site",
  "blog.new": "Nieuw artikel",
  "blog.publish": "Publiceren",
  "blog.publish_count": "{count, plural, one {Eén artikel publiceren} other {# artikelen publiceren}}",
  "blog.published_title": "Publicatie gestart",
  "blog.published_body": "Revisie r{revision} met {count, plural, one {één artikel} other {# artikelen}} gaat naar de website.",
  "blog.publish_failed": "Publiceren lukte niet",
  "blog.tabs": "Blogonderdelen",
  "blog.tab_posts": "Artikelen",
  "blog.tab_calendar": "Kalender",
  "blog.tab_sources": "Bronnen",
  "blog.empty_title": "Nog geen artikelen",
  "blog.empty_body": "Begin met een brief: onderwerp, zoekwoord en de talen met het land van de lezer.",
  "blog.blocking": "{count, plural, one {# blokkerend punt} other {# blokkerende punten}}",
  "blog.no_blocking": "Geen blokkerende punten",
  "blog.warnings": "{count, plural, one {# aandachtspunt} other {# aandachtspunten}}",
  "blog.words": "{count, plural, one {# woord} other {# woorden}}",
  "blog.status.brief": "Brief",
  "blog.status.in_progress": "Bezig",
  "blog.status.ready": "Klaar om te publiceren",
  "blog.status.published": "Gepubliceerd",
  "blog.status.archived": "Gearchiveerd",
  "blog.locale_status.empty": "Nog geen tekst",
  "blog.locale_status.draft": "Concept",
  "blog.locale_status.in_review": "Ter review",
  "blog.locale_status.approved": "Goedgekeurd",
  "blog.locale_status.rejected": "Afgewezen",
  "blog.locale_status.live": "Live",
  "blog.cal_prev": "Vorige maand",
  "blog.cal_next": "Volgende maand",
  "blog.cal_plan": "Artikel plannen op {date}",
  "blog.cal_free_week": "Week {week} van deze maand is nog vrij",
  "blog.cal_full": "Elke week van deze maand heeft een artikel",
  "blog.src_title": "Bronnenlijst",
  "blog.src_lead": "Feiten die per land van de lezer verschillen (belasting, financiering, NIE) komen alleen hieruit. AI noemt niets wat hier niet staat.",
  "blog.src_add": "Bron toevoegen",
  "blog.src_edit": "Bron bewerken",
  "blog.src_dialog_body": "Een bron is een instantie of document met een of meer feiten, per taal geformuleerd. Leg vast voor welk land van de lezer de bron geldt.",
  "blog.src_general": "Voor iedere lezer",
  "blog.src_publisher": "Uitgever",
  "blog.src_name": "Titel",
  "blog.src_url": "Adres (https)",
  "blog.src_url_hint": "Openbare bron; laat leeg voor eigen productfeiten en vul dan een referentie in.",
  "blog.src_reference": "Interne referentie",
  "blog.src_country": "Land van de lezer",
  "blog.src_country_hint": "Bijvoorbeeld Nederland voor box 3. Spaanse regels gelden voor iedere lezer.",
  "blog.src_topic": "Onderwerp",
  "blog.src_status_label": "Status",
  "blog.src_status.active": "Actief",
  "blog.src_status.needs_check": "Te controleren",
  "blog.src_status.retired": "Vervallen",
  "blog.src_checked_on": "Gecontroleerd op",
  "blog.src_checked": "gecontroleerd {date}",
  "blog.src_used": "{count, plural, =0 {nog niet gebruikt} one {in # taalversie} other {in # taalversies}}",
  "blog.src_facts": "Feiten",
  "blog.src_facts_hint": "Eén feit per blok, zo letterlijk en voorzichtig mogelijk. Formuleer het in elke taal waarin je erover schrijft.",
  "blog.src_fact_in": "Feit {n} ({locale})",
  "blog.src_fact_add": "Feit toevoegen",
  "blog.src_fact_remove": "Feit verwijderen",
  "blog.src_note": "Notitie",
  "blog.src_saved": "Bron opgeslagen",
  "blog.topic.tax": "Belasting",
  "blog.topic.financing": "Financiering",
  "blog.topic.nie": "NIE",
  "blog.topic.purchase_process": "Koopproces",
  "blog.topic.costs": "Kosten",
  "blog.topic.residency": "Verblijf",
  "blog.topic.inheritance": "Erfrecht",
  "blog.topic.rental": "Verhuur",
  "blog.topic.area": "Gebied",
  "blog.topic.product": "Product",
  "blog.topic.general": "Algemeen",
  "blog.brief_title": "Nieuwe brief",
  "blog.brief_body": "Wat het artikel moet beantwoorden en voor wie. AI schrijft per taal een concept met feiten uit je bronnenlijst.",
  "blog.brief_topic": "Onderwerp",
  "blog.brief_topic_hint": "De vraag of het onderwerp, bijvoorbeeld NIE aanvragen en belasting na de koop.",
  "blog.brief_keyword": "Hoofdzoekwoord",
  "blog.brief_secondary": "Andere zoekwoorden",
  "blog.brief_secondary_hint": "Gescheiden door komma's",
  "blog.brief_category": "Categorie",
  "blog.brief_no_category": "Geen categorie",
  "blog.brief_planned": "Gepland op",
  "blog.brief_angle": "Invalshoek",
  "blog.brief_angle_hint": "Wat weet of kan de lezer na afloop?",
  "blog.brief_locales": "Talen",
  "blog.brief_locales_hint": "Per taal het land van de lezer: dat bepaalt welke landfeiten (belasting, financiering) gelden.",
  "blog.brief_locales_hint_product": "Per taal een eigen zoekwoord, als dat anders is dan het hoofdzoekwoord.",
  "blog.brief_reader": "Land van de lezer",
  "blog.brief_locale_keyword": "Zoekwoord in deze taal",
  "blog.brief_areas": "Gekoppelde gebieden",
  "blog.brief_create": "Brief maken",
  "blog.edit_brief": "Brief bewerken",
  "blog.locales": "Taalversies",
  "blog.live_at": "Live op {path}",
  "blog.for_country": "Voor lezers uit {country}",
  "blog.for_everyone": "Voor iedere lezer",
  "blog.keyword_is": "zoekwoord {keyword}",
  "blog.origin.ai": "AI-concept",
  "blog.origin.ai_edited": "AI-concept, bewerkt",
  "blog.origin.human": "Zelf geschreven",
  "blog.ai_draft": "AI-concept maken",
  "blog.ai_again": "Nieuw AI-concept",
  "blog.ai_done": "AI-concept klaar",
  "blog.ai_done_body": "{count, plural, =0 {Geen blokkerende punten.} one {Eén blokkerend punt om op te lossen.} other {# blokkerende punten om op te lossen.}}",
  "blog.ai_done_test": "Opzet van de testadapter: herschrijf elke tekst voordat je goedkeurt.",
  "blog.ai_failed": "AI-concept lukte niet",
  "blog.saved": "Opgeslagen",
  "blog.save_failed": "Opslaan lukte niet",
  "blog.submit": "Ter review",
  "blog.submitted": "Ter review aangeboden",
  "blog.submit_failed": "Ter review aanbieden lukte niet",
  "blog.approve": "Goedkeuren",
  "blog.request_changes": "Wijzigingen vragen",
  "blog.approved_by": "Goedgekeurd op {date}",
  "blog.approve_title": "{locale} goedkeuren",
  "blog.approve_body": "Je keurt precies deze tekst goed. Elke latere wijziging vraagt een nieuwe review.",
  "blog.approved_toast": "Goedgekeurd",
  "blog.changes_title": "Wijzigingen vragen",
  "blog.changes_body": "Beschrijf wat er anders moet. De taalversie gaat terug naar concept.",
  "blog.changes_toast": "Teruggezet naar concept",
  "blog.checklist": "Controlelijst",
  "blog.checklist_facts": "Ik heb elk feit gecontroleerd met de bronnen",
  "blog.checklist_country": "Het advies past bij het land van de lezer",
  "blog.checklist_noPromises": "Er staan geen beloftes over rendement, beschikbaarheid of uitkomsten in",
  "blog.checklist_links": "De links kloppen en wijzen naar de juiste pagina's",
  "blog.checklist_hint": "Vink alle punten aan om goed te keuren.",
  "blog.review_note": "Notitie bij de review",
  "blog.test_title": "Testuitvoer, geen taalmodel",
  "blog.test_body": "Deze opzet komt van de testadapter: feiten uit de bronnenlijst onder koppen, met [TEST]-markeringen. Herschrijf elke tekst. Goedkeuren kan pas als er geen markering meer in staat; de database dwingt dat ook af.",
  "blog.empty_locale_title": "Nog geen tekst in deze taal",
  "blog.empty_locale_body": "Laat AI een concept maken met {facts, plural, one {# feit} other {# feiten}} uit de bronnenlijst en {targets, plural, one {# linkdoel} other {# linkdoelen}}, of schrijf zelf.",
  "blog.editor_label": "Tekst in {locale}",
  "blog.f_title": "Titel (H1)",
  "blog.f_seo_title": "SEO-titel",
  "blog.f_slug": "Slug",
  "blog.slug_hint": "Kleine letters en streepjes; wordt het adres van het artikel.",
  "blog.slug_fixed": "Het adres ligt vast sinds de eerste publicatie.",
  "blog.f_meta": "Metabeschrijving",
  "blog.counter": "{n} tekens (mik op {min} tot {max})",
  "blog.f_excerpt": "Samenvatting",
  "blog.f_intro": "Inleiding",
  "blog.f_sections": "Secties",
  "blog.f_level": "Niveau",
  "blog.f_heading": "Kop {n}",
  "blog.f_paragraph": "Alinea {n}",
  "blog.f_bullets": "Opsomming",
  "blog.f_bullets_hint": "Eén punt per regel",
  "blog.add_paragraph": "Alinea toevoegen",
  "blog.add_section": "Sectie toevoegen",
  "blog.move_up": "Sectie omhoog",
  "blog.move_down": "Sectie omlaag",
  "blog.remove_section": "Sectie verwijderen",
  "blog.f_faq": "Vragen",
  "blog.f_q": "Vraag {n}",
  "blog.f_a": "Antwoord {n}",
  "blog.add_faq": "Vraag toevoegen",
  "blog.remove_faq": "Vraag verwijderen",
  "blog.f_links": "Interne links",
  "blog.f_links_hint": "Het label moet letterlijk in de gekozen alinea staan; de site maakt er een link naar de pagina van het doel.",
  "blog.f_link_label": "Label",
  "blog.f_link_missing": "Dit label staat niet in de gekozen alinea",
  "blog.f_link_place": "In",
  "blog.f_link_target": "Naar",
  "blog.add_link": "Link toevoegen",
  "blog.remove_link": "Link verwijderen",
  "blog.place_intro": "Inleiding",
  "blog.place": "{section}, alinea {paragraph}",
  "blog.target.area": "Gebied",
  "blog.target.property": "Woning",
  "blog.target.post": "Artikel",
  "blog.target.page": "Pagina",
  "blog.page.contact": "Contact",
  "blog.page.sell": "Verkopen",
  "blog.page.properties": "Alle woningen",
  "blog.page.areas": "Gebieden",
  "blog.page.demo": "Demo aanvragen",
  "blog.page.switch": "Overstappen",
  "blog.page.blog": "Blogoverzicht",
  "blog.side_label": "Controles en voorbeeld",
  "blog.snippet": "Zo ongeveer in zoekresultaten",
  "blog.snippet_empty": "Nog geen titel",
  "blog.snippet_empty_desc": "Nog geen metabeschrijving",
  "blog.checks": "Controles",
  "blog.checks_live": "Live; dubbel- en overlapcontrole bij opslaan",
  "blog.checks_saved": "Laatst opgeslagen versie",
  "blog.checks_ok": "{count, plural, one {# controle in orde} other {# controles in orde}}",
  "blog.sev_block": "Blokkeert goedkeuren",
  "blog.sev_warn": "Aandachtspunt",
  "blog.facts": "Feiten uit de bronnenlijst",
  "blog.facts_hint": "Vink aan welke feiten het artikel gebruikt. Getallen in de tekst moeten in een aangevinkt feit staan.",
  "blog.facts_empty": "Geen actieve feiten voor dit land. Voeg ze toe in Bronnen.",
  "blog.history": "Geschiedenis",
  "chat.title": "Chatbot",
  "chat.lead": "Gesprekken, instellingen en kennis van de chatbot op je website.",
  "chat.lead_site": "Gesprekken, instellingen en kennis van de chatbot op {site}.",
  "chat.tabs": "Chatbotonderdelen",
  "chat.tab_conversations": "Gesprekken",
  "chat.tab_settings": "Instellingen",
  "chat.tab_knowledge": "Kennis",
  "chat.stat_conversations": "Gesprekken (30 dagen)",
  "chat.stat_turns": "Vragen beantwoord",
  "chat.stat_leads": "Aanvragen uit de chat",
  "chat.stat_cost": "Kosten",
  "chat.filter": "Toon",
  "chat.f_all": "Alles",
  "chat.f_lead": "Met aanvraag",
  "chat.f_open": "Zonder aanvraag",
  "chat.search": "Zoeken in gesprekken",
  "chat.search_placeholder": "Woord uit een vraag of antwoord",
  "chat.no_question": "Geen vraag",
  "chat.turns": "{count, plural, one {# vraag} other {# vragen}}",
  "chat.mobile": "Mobiel",
  "chat.desktop": "Desktop",
  "chat.status_lead": "Aanvraag",
  "chat.test": "Test",
  "chat.empty_title": "Nog geen gesprekken",
  "chat.empty_body": "Zodra bezoekers de chatbot op je site gebruiken, zie je de gesprekken hier.",
  "chat.conversation": "Gesprek van {date}",
  "chat.unknown_page": "onbekende pagina",
  "chat.lead_made": "Aanvraag gemaakt: {name}",
  "chat.open_lead": "Aanvraag van {name} openen",
  "chat.visitor": "Bezoeker",
  "chat.assistant": "Assistent",
  "chat.feedback_bad": "Bezoeker vond dit antwoord niet nuttig",
  "chat.test_answer": "Testantwoord zonder taalmodel",
  "chat.ref.property": "Woning",
  "chat.ref.page": "Pagina",
  "chat.ref.post": "Artikel",
  "chat.ref.area": "Gebied",
  "chat.s_general": "Algemeen",
  "chat.s_active_on": "Chatbot staat aan op de site",
  "chat.s_active_off": "Chatbot is gepauzeerd",
  "chat.s_active_hint": "Pauzeren werkt meteen; de knop verdwijnt na de volgende publicatie.",
  "chat.s_name": "Naam van de assistent",
  "chat.s_tone": "Toon",
  "chat.tone.warm": "Warm en persoonlijk",
  "chat.tone.business": "Zakelijk en precies",
  "chat.tone.brief": "Kort en bondig",
  "chat.s_texts": "Begroeting en snelle knoppen",
  "chat.s_language": "Taal",
  "chat.s_greeting": "Begroeting ({locale})",
  "chat.s_quick": "Snelle knoppen (hoogstens vier)",
  "chat.s_quick_label": "Knop {n}",
  "chat.s_quick_prompt": "Vraag achter knop {n}",
  "chat.s_quick_add": "Knop toevoegen",
  "chat.s_remove": "Verwijderen",
  "chat.s_look": "Uiterlijk",
  "chat.s_look_hint": "Kleuren komen uit het designsysteem van de site; kies welke set.",
  "chat.s_palette": "Kleurenset",
  "chat.palette.brand": "Merkkleur",
  "chat.palette.deep": "Donker",
  "chat.palette.warm": "Warm",
  "chat.s_position": "Plek op de pagina",
  "chat.pos_end": "Rechtsonder",
  "chat.pos_start": "Linksonder",
  "chat.s_limits": "Overdracht en limieten",
  "chat.s_handoff": "Bezoekers kunnen hun vraag met toestemming doorzetten naar een aanvraag",
  "chat.s_handoff_product": "Bezoekers kunnen met toestemming een demo of contact aanvragen",
  "chat.s_turns": "Vragen per gesprek",
  "chat.s_turns_hint": "Daarna stelt de chatbot voor om contact op te nemen.",
  "chat.s_daily": "Kostenplafond per dag",
  "chat.s_daily_hint": "Bovenop het maandbudget van de organisatie.",
  "chat.s_updated": "Laatst gewijzigd {date}",
  "chat.saved": "Instellingen opgeslagen",
  "chat.save_failed": "Opslaan lukte niet",
  "chat.k_title": "Kennis van de chatbot",
  "chat.k_lead": "Naast het actuele aanbod en de gepubliceerde blog gebruikt de chatbot alleen deze teksten: vragen, het kantoor, het koopproces en kosten.",
  "chat.k_lead_product": "Naast de gepubliceerde blog gebruikt de chatbot alleen deze teksten over het product.",
  "chat.k_add": "Kennis toevoegen",
  "chat.k_edit": "Kennis bewerken",
  "chat.k_dialog_body": "Eén vraag of onderwerp per item, met het antwoord dat de chatbot mag geven. Optioneel een pagina waar het antwoord naar verwijst.",
  "chat.k_kind": "Soort",
  "chat.kind.faq": "Vraag",
  "chat.kind.company": "Kantoor",
  "chat.kind.process": "Werkwijze",
  "chat.kind.costs": "Kosten",
  "chat.kind.area": "Gebied",
  "chat.kind.product": "Product",
  "chat.k_locale": "Taal",
  "chat.k_page": "Verwijst naar",
  "chat.k_no_page": "Geen pagina",
  "chat.k_active": "Actief",
  "chat.k_inactive": "Inactief",
  "chat.k_question": "Vraag of titel",
  "chat.k_answer": "Antwoord",
  "chat.k_answer_hint": "Alleen wat je zelf ook zou zeggen. Geen beloftes over prijzen of uitkomsten.",
  "blog.check.test_output": "Er staat nog testuitvoer ([TEST]) in de tekst.",
  "blog.check_ok.test_output": "Geen testuitvoer",
  "blog.check.title": "Titel van {length} tekens; mik op 20 tot 75.",
  "blog.check_ok.title": "Titellengte",
  "blog.check.seo_title": "SEO-titel van {length} tekens; mik op 30 tot 60.",
  "blog.check_ok.seo_title": "SEO-titel",
  "blog.check.meta_description": "Metabeschrijving van {length} tekens; mik op 120 tot 160.",
  "blog.check_ok.meta_description": "Metabeschrijving",
  "blog.check.keyword_title": "Zoekwoord \"{keyword}\" staat niet in de titel of SEO-titel.",
  "blog.check_ok.keyword_title": "Zoekwoord in de titel",
  "blog.check.keyword_intro": "Zoekwoord \"{keyword}\" staat niet in de inleiding.",
  "blog.check_ok.keyword_intro": "Zoekwoord in de inleiding",
  "blog.check.keyword_heading": "Geen enkele kop bevat een zoekwoord.",
  "blog.check_ok.keyword_heading": "Zoekwoord in een kop",
  "blog.check.keyword_slug": "De slug bevat het zoekwoord niet.",
  "blog.check_ok.keyword_slug": "Zoekwoord in de slug",
  "blog.check.headings": "Koppen: minstens twee H2, H3 alleen onder een H2, uniek en niet gelijk aan de titel ({issues}).",
  "blog.check_ok.headings": "Kopstructuur",
  "blog.check.length": "{words} woorden; een goed artikel heeft er 600 tot 2.500 (onder 300 kan niet).",
  "blog.check_ok.length": "Lengte",
  "blog.check.internal_links": "Interne links: {count} (minstens 2 naar verschillende doelen), labels die niet in de alinea staan: {badLabels}.",
  "blog.check_ok.internal_links": "Interne links",
  "blog.check.link_targets": "Linkdoelen: link naar een gebied of woning en alleen naar bestaande pagina's ({invalid}).",
  "blog.check_ok.link_targets": "Linkdoelen bestaan",
  "blog.check.faq": "{count} vragen; twee of meer helpen lezers en zoekmachines.",
  "blog.check_ok.faq": "Vragen",
  "blog.check.facts_known": "{unknown} feit(en) horen niet bij de bronnenlijst voor dit land.",
  "blog.check_ok.facts_known": "Feiten uit de bronnenlijst",
  "blog.check.numbers": "Getallen zonder bron in de tekst: {numbers}. Gebruik alleen getallen uit gekoppelde feiten of woningen.",
  "blog.check_ok.numbers": "Getallen met bron",
  "blog.check.country_facts": "Geen enkel feit voor lezers uit {country}: het artikel geeft dan alleen algemeen advies.",
  "blog.check_ok.country_facts": "Feiten voor het land van de lezer",
  "blog.check.unique_title": "Titel of slug bestaat al op deze site: {titles}.",
  "blog.check_ok.unique_title": "Unieke titel en slug",
  "blog.check.cannibalization": "Een ander artikel gebruikt hetzelfde hoofdzoekwoord: {titles}.",
  "blog.check_ok.cannibalization": "Eigen zoekwoord",
  "blog.check.overlap": "{percent}% van de tekst overlapt met een ander artikel (maximaal 20%).",
  "blog.check_ok.overlap": "Geen dubbele inhoud",
  "blog.check.readability": "Gemiddeld {average} woorden per zin; korter leest makkelijker (24 of minder).",
  "blog.check_ok.readability": "Leesbaarheid",
  "blog.check.copy": "Copyregels: {rules}.",
  "blog.check_ok.copy": "Copyregels",
  "chat.s_privacy": "Privacy",
  "chat.s_retention": "Bewaartermijn gesprekken (dagen)",
  "chat.s_retention_hint": "Tussen 30 en 730 dagen. Daarna verwijdert BRES de berichten; de telling blijft voor de statistiek.",
  "chat.s_retention_note": "Gesprekken die een bezoeker doorzet naar een aanvraag, blijven bij die aanvraag. De chatbot noemt de termijn in het chatvenster; de privacyverklaring van de site volgt na de volgende publicatie."
}
